// extracted by mini-css-extract-plugin
export default {"container":"ProjectCreation_container__Z4vQm"};